import {action, makeAutoObservable} from "mobx";
import {PackageDeliveryService} from "../../../service/packageDelivery/PackageDeliveryService";
import CommonStore from "../../../stores/CommonStore";
import TypeCorrespond from "../../../entities/TypeCorrespond";

const ERROR_MAP = {
    unauthorized: ["ERROR_00_401_00"]
}

class SendToDeliveryAgencyStore {

    public packageDeliveryOrderId: string;
    public typeCorrespond: TypeCorrespond;
    public loading: boolean;
    public commonStore: CommonStore;

    constructor(commonStore: CommonStore, packageDeliveryOrderId: string) {
        this.packageDeliveryOrderId = packageDeliveryOrderId;
        this.typeCorrespond = TypeCorrespond.TRANSCARGO;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    @action
    public async sendToDeliveryAgency(typeCorrespond: TypeCorrespond) {
        this.loading = true;
        const response = await PackageDeliveryService.sendToDeliveryAgency(this.packageDeliveryOrderId, typeCorrespond);
        this.loading = false;

        if (!response.success && response.status === 400) {
            await this.commonStore.showErrorToast('No se pudo enviar el pedido a la agencia de delivery');
        } else if (response.success) {
            await this.commonStore.showSuccessToast('Envío creado en Solved exitosamente');
        } else {
            this.commonStore.processErrors(response);
        }

        this.processError(response.error);
        return response.success;
    }

    processError(error?: string) {
        if (error) {
            if (ERROR_MAP.unauthorized.includes(error)) {
                this.commonStore.showErrorToast(error);
            }
        }
    }
}

export default SendToDeliveryAgencyStore;

